import React, { useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuDate, NuInput, NuTextArea } from '../../../../Components/Utils/Input';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import UseCustomerDropDownNew from '../../../../Components/Hooks/useCustomerSearch';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import { useToast } from '../../../../Components/Others/ToastServices';
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];


function CreateClientTickets() {
  const navigate = useNavigate();
  const {  addFormData } = useAddFormData();
  const toast = useToast();
      const [image, setImage] = useState([]);
     const [selectedFile, setSelectedFile] = useState(null);
        const [searchClient, setSearchClient] = useState("");
  
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );

  const { value: Status,getData:refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Support_Tickets"
  ); 
  const { value: TicketType,getData:refTicketType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Ticket_Type"
  );  

  const { value: Priority,getData:refPriority } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Priority_Support_Tickets"
  );  

          const { data: contract } = UseDropDown(`/contract/drop-down`);
  
     const [createNew, setCreateNew] = useState({
      contractId:null,
      subject:"",
      message:"",
      clientId:null,
      ticketType:"",
      priority:"",
      status:"",
      attachments: [],

  });

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          // placement: "bottomRight",
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        console.log("fname", fileName);
        let fileExtention = fileName.split(".").reverse()[0];
        if (filetype?.includes(fileExtention)) {
          tempArr.push(fileName);
        } else {
          let x = URL.createObjectURL(item);
          tempArr.push(x);
        }
      }
    });
    console.log(tempArr, "temp");
    setImage(tempArr);
  }

  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      // console.log('fname',fileName);
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // clientId: yup.string().required("Client is required!"),
      // contractId: yup.string().required("Contract is required!"),
      
          }),
    onSubmit: async (value, { resetForm }) => {

      let formData = new FormData();
      const valueWithProducts = {
        ...value,
        // products: productsString,
        // services: servicesString,
        // emails: emailsString,
      };
      formData.append("json_data", JSON.stringify(valueWithProducts));
      // formData.append("attachments", image.raw);
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
           addFormData("/tickets/raise-ticket ", formData, resetForm);
    },
  });
 
 

  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full"> 
         <Breadcrumb
                  items={[
                    // { name: "Testing&Commissioning" },
                    {   name: "Client-Tickets" ,
                      link:"/tickets/client-tickets"
                    },
                    { name: "Create" },
                  ]}
                />         
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                Client Ticket :
              </p>
            </div>
            {/* <FormikSelectTwo
              label="Type"
              Options={[
                { value: "Contractual", label: "Contractual" },
      { value: "Non-Contractual", label: "Non-Contractual" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="Type"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            /> */}

           {/* <FormikSelectTwo
                         label="Client"
                         Options={client}
                         formik={formik}
                         placeholder="Choose"
                         name="clientId"
                         isRequired={true}
           
                         width="w-full md:w-1/3 md:-mt-2"
                       /> */}

<FormikSelectTwo
              label="Contract "
              Options={contract}
              formik={formik}
              placeholder="Choose"
              name="contractId"
              // isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />

             <NuInput
             type="text"
              label="Subject"
      //         Options={[
      //           { value: "project1", label: "Project X" },
      // { value: "project2", label: "Project Y" },
      //         ]}
              formik={formik}
              placeholder="Choose"
              name="subject"

              width="w-full md:w-1/3 md:-mt-2"
            />

<DropDownAddMetaData
              label="Priority"
              Options={Priority}
              formik={formik}
              placeholder="Choose"
              name="priority"

              width="w-full md:w-1/3 md:-mt-2"
              displayProperty={"Priority"}
              propertyName={"Priority_Support_Tickets"}
              getFunc={refPriority}

            /> 

<DropDownAddMetaData
              label="Ticket Type"
              Options={TicketType}
              formik={formik}
              placeholder="Choose"
              name="ticketType"

              width="w-full md:w-1/3 md:-mt-2"
              displayProperty={"Ticket Type"}
              propertyName={"Ticket_Type"}
              getFunc={refTicketType}
              
            /> 

             {/* <DropDownAddMetaData
                          label="Status"
                          Options={Status}
                          formik={formik}
                          placeholder="Choose"
                          name="status"
            
                          width="w-full md:w-1/3 md:-mt-2"
                          displayProperty={"Status"}
                          propertyName={"Status_Support_Tickets"}
                          getFunc={refStatus}
            
                        />  */}

             <NuTextArea
                          type="text"
                          label="Message"
                          placeholder="Message"
                          formik={formik}
                          name="message"
                          width="w-full md:w-1/2 "
                        />

<Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach" 
                multiple={true}
                removeImages={removeImages}
              />
            {/* <NuDate
              label="Ticket Date"
              placeholder="Ticket Date"
              formik={formik}
              name="TicketDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            />

<NuDate
              label="Response Date"
              placeholder="Response Date"
              formik={formik}
              name="ResponseDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            /> */}

{/* <DropDownAddMetaData
              label="Status"
              Options={[
                { value: "Pending", label: "Pending" },
      { value: "Completed", label: "Completed" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="Status"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
              displayProperty={"Status"}
              propertyName={"Status"}
            /> */}
           
           
           <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                 <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateClientTickets
